'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

exports.default = function (value) {
  return typeof value === 'string' ? !(0, _ramda.isEmpty)(value.trim()) : !(0, _ramda.isNil)(value) && !(0, _ramda.isEmpty)(value);
};